import * as Types from '../types-api.generated';

import { NftIdentifiersFragment, UserLightFragment, MomentStatsFragment, MediaFragment, EditionSaleConfigurationFragment, DropSaleConfigurationFragment, WorldOverviewFragment } from '../api-fragments.generated';
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { apiFetcher } from 'lib/clients/graphql';

import { ClientError } from "graphql-request";
import { Address } from "viem";
import { ChainId } from "lib/chains";

export type ApiNftVariables = Types.Exact<{
  chainId: Types.Scalars['ChainId'];
  contractAddress: Types.Scalars['Address'];
  tokenId: Types.Scalars['Int'];
}>;


export type ApiNft = { nft: { name: string | null, chainId: ChainId, contractAddress: Address, tokenId: number, collection: { name: string, collectionImageUrl: string | null }, creator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address }, media: { __typename: 'ImageMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, imageMimeType: Types.ApiImageMimeType } | { __typename: 'ModelMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, modelMimeType: Types.ApiModelMimeType, modelStaticUrl: string } | { __typename: 'VideoMedia', previewUrl: string | null, processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, staticUrl: string | null, url: string, videoMimeType: Types.ApiVideoMimeType } | null } | null };



export const ApiNftDocument = /*#__PURE__*/ `
    query Nft($chainId: ChainId!, $contractAddress: Address!, $tokenId: Int!) {
  nft: nftV2(
    nft: {chainId: $chainId, contractAddress: $contractAddress, tokenId: $tokenId}
  ) {
    ...NftIdentifiersFragment
    name
    collection {
      name
      collectionImageUrl
    }
    creator {
      ...UserLightFragment
    }
    media {
      ...MediaFragment
    }
  }
}
    ${NftIdentifiersFragment}
${UserLightFragment}
${MediaFragment}`;

export const useNft = <
      TData = ApiNft,
      TError = ClientError
    >(
      variables: ApiNftVariables,
      options?: Omit<UseQueryOptions<ApiNft, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ApiNft, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ApiNft, TError, TData>(
      {
    queryKey: ['Nft', variables],
    queryFn: apiFetcher<ApiNft, ApiNftVariables>(ApiNftDocument, variables),
    ...options
  }
    )};

useNft.getKey = (variables: ApiNftVariables) => ['Nft', variables];

export const useInfiniteNft = <
      TData = InfiniteData<ApiNft>,
      TError = ClientError
    >(
      variables: ApiNftVariables,
      options: Omit<UseInfiniteQueryOptions<ApiNft, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ApiNft, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ApiNft, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['Nft.infinite', variables],
      queryFn: (metaData) => apiFetcher<ApiNft, ApiNftVariables>(ApiNftDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteNft.getKey = (variables: ApiNftVariables) => ['Nft.infinite', variables];


useNft.fetcher = (variables: ApiNftVariables, options?: RequestInit['headers']) => apiFetcher<ApiNft, ApiNftVariables>(ApiNftDocument, variables, options);
